import React from 'react';
import withStyles, { StyleRules } from '@material-ui/core/styles/withStyles';
import Chip, { ChipProps } from '@material-ui/core/Chip';

import { SERVICE_COLOR_2, TEXT_PRIMARY } from '../../styles/variables';
import {
  V1UsersiteSpecificCategoriesGetOneTypePayloadKind,
  V1UsersiteSpecificCategoriesGetOneTypePayloadKindType,
} from '~/models/schema';

interface Props extends ChipProps {
  kind: V1UsersiteSpecificCategoriesGetOneTypePayloadKindType;
}

const styles = (theme): StyleRules => ({
  root: {
    color: ({ kind }: Props) =>
      kind === V1UsersiteSpecificCategoriesGetOneTypePayloadKind.STRONG
        ? theme.palette.common.white
        : TEXT_PRIMARY,
    backgroundColor: ({ kind }: Props) =>
      kind === V1UsersiteSpecificCategoriesGetOneTypePayloadKind.STRONG
        ? '#FF3C10'
        : SERVICE_COLOR_2,
    borderRadius: 5,
    margin: theme.spacing(0.5),
    position: 'relative',
    minWidth: 'auto',
    maxWidth: 200,
    width: 'calc(50% - 10px)',
    height: 'auto',
    padding: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      minWidth: 160,
      maxWidth: 250,
      width: 'auto',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 350,
    },
  },
  deletable: {
    width: 'auto',
    maxWidth: 'none',
    padding: theme.spacing(1, 4),
  },
  label: {
    paddingLeft: 0,
    paddingRight: 0,
    fontSize: 13,
    whiteSpace: 'normal',
  },
  deleteIcon: {
    position: 'absolute',
    right: 0,
    width: 19,
    height: 19,
    color: theme.palette.common.white,
  },
});

const StyledChip = ({ kind, ...rest }: Props) => <Chip {...rest} />;

export default withStyles(styles)(StyledChip);
